import React from 'react'

const AccountFormInput = ({
  label,
  name,
  value,
  onChange,
  type = 'text',
  required = false,
  placeholder,
  containerClassName = '',
  labelClassName = '',
  inputClassName = '',
  ...rest
}) => {
  const defaultInputClasses =
    'px-3.5 py-3 border border-slate-200 rounded-xl text-[13px] bg-white transition-all duration-200 focus:outline-none focus:border-citrus-red text-slate-900 w-full'

  return (
    <div className={containerClassName}>
      <label
        htmlFor={name}
        className={`block text-[15px] text-slate-700 mb-2 ${labelClassName}`}
      >
        {label} {required && <span className="text-citrus-red">*</span>}
      </label>
      <input
        id={name}
        type={type}
        name={name}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${defaultInputClasses} ${inputClassName}`}
        required={required}
        {...rest}
      />
    </div>
  )
}

export default AccountFormInput
